<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'DOCS_MODULE.CATEGORY.CATEGORIES_LIST' | translate"
    [viewLoading$]="dataSource?.loading$"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div>
        <button
          mat-raised-button
          class="btn btn-light-primary"
          (click)="manageSharingConfigs($event)"
        >
          <span>{{ 'DOCS_MODULE.CATEGORY.SHARING_CONFIGS' | translate }}</span>
        </button>
        <ng-template ngxPermissionsOnly="canAddDocumentCategory">
          <button mat-raised-button class="btn btn-primary ml-2" (click)="addCategory($event)">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'DOCS_MODULE.CATEGORY.ADD_CATEGORY' | translate }}</span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.CATEGORY.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let category">{{ category.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.CATEGORY.ID' | translate }}</mat-label>
              <input
                matInput
                #searchIdInput
                [placeholder]="'DOCS_MODULE.CATEGORY.ID' | translate"
              />
              <button
                *ngIf="searchIdInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchIdInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.CATEGORY.NAME' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let category">
            <span
              [matTooltip]="canViewCategory() ? 'View Category' : null"
              [class.clickable]="canViewCategory()"
              (dblclick)="viewCategory($event, category)"
              >{{ category.name }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.CATEGORY.NAME' | translate }}</mat-label>
              <input
                matInput
                #searchNameInput
                [placeholder]="'DOCS_MODULE.CATEGORY.NAME' | translate"
              />
              <button
                *ngIf="searchNameInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchNameInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="entityTypes">
          <mat-header-cell *matHeaderCellDef>{{
            'DOCS_MODULE.CATEGORY.ENTITY_TYPES' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let category">
            <ng-container *ngFor="let type of category.entity_types || []; let idx = index">
              {{
                stringUtils.formatEnumString(type.entity_type) +
                  (idx !== category.entity_types?.length - 1 ? ', ' : '')
              }}
            </ng-container>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchEntityTypes">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.CATEGORY.ENTITY_TYPES' | translate }}</mat-label>
              <mat-select #searchEntityTypesSelect multiple>
                <mat-option *ngFor="let type of entityTypes" [value]="type.entity_type">{{
                  stringUtils.formatEnumString(type.entity_type)
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="createdBySuperAdmin">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.CATEGORY.ORIGIN' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let category">
            <div
              class="ks-badge-md ks-badge-light-{{
                category.created_by_super_admin ? 'secondary' : 'neutral'
              }}"
            >
              {{ category.created_by_super_admin ? 'Global' : 'Company' }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchOrigin">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.CATEGORY.ORIGIN' | translate }}</mat-label>
              <mat-select
                #searchOriginSelect
                [placeholder]="'DOCS_MODULE.CATEGORY.ORIGIN' | translate"
              >
                <mat-option *ngFor="let origin of originOptions" [value]="origin.value">{{
                  origin.label
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="notificationLevel">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.CATEGORY.NOTIFICATION_LEVEL' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let category">{{
            stringUtils.formatEnumString(category.notification_level)
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchNotificationLevel">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.CATEGORY.NOTIFICATION_LEVEL' | translate }}</mat-label>
              <mat-select
                #searchNotificationLevelSelect
                [placeholder]="'DOCS_MODULE.CATEGORY.NOTIFICATION_LEVEL' | translate"
              >
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let level of NotificationLevels" [value]="level">{{
                  stringUtils.formatEnumString(level)
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="mobileVisible">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.CATEGORY.MOBILE_VISIBLE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let category">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getStatusClass(category.mobile_visible?.toString())
              }} label-inline text-center"
            >
              {{ getStatusLabel(category.mobile_visible?.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchMobileVisible">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.CATEGORY.MOBILE_VISIBLE' | translate }}</mat-label>
              <mat-select
                #searchMobileVisibleSelect
                [placeholder]="'DOCS_MODULE.CATEGORY.MOBILE_VISIBLE' | translate"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let category">
            <ng-template ngxPermissionsOnly="canViewDocumentCategory">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Category"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewCategory($event, category)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditDocumentCategory">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Category"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="updateCategory($event, category)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedCols" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarCols"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
